import * as Types from '../../../graphql';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetCurrentLunaCalculQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  userRole?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetCurrentLunaCalculQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getCurrentLunaCalculUsingGET?: { __typename?: 'payroll_LunaCalculRepresentation', month?: number | null, closedByClient?: boolean | null, closedByExpert?: boolean | null, errorCloseByExpert?: string | null, errorOpenByExpert?: string | null, blocata?: boolean | null } | null } | null, accounts?: { __typename?: 'accounts', getSuperExpertProgressManagementPayrollStatusUsingGET?: { __typename?: 'accounts_PayrollStatusRepresentation', payrollStartMonth?: number | null, payrollType?: string | null } | null } | null };

export type GetClientCaenDataQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  atDate?: Types.InputMaybe<Types.Scalars['Int']>;
  eom?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type GetClientCaenDataQuery = { __typename?: 'Query', accounts?: { __typename?: 'accounts', GetClientUsingGET?: { __typename?: 'accounts_ClientRepresentation', externalId?: string | null, sysCaenCode?: { __typename?: 'accounts_CaenCodeRepresentation', code?: string | null, description?: string | null } | null, sysConstructionCaenCode?: { __typename?: 'accounts_CaenCodeRepresentation', code?: string | null, description?: string | null } | null } | null } | null };

export type GetStatusLunaCalculQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetStatusLunaCalculQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getStatusLunaCalculUsingGET?: { __typename?: 'payroll_LunaCalculRepresentation', month?: number | null, closedByClient?: boolean | null, closedByExpert?: boolean | null, errorCloseByExpert?: string | null, errorOpenByExpert?: string | null, blocata?: boolean | null } | null } | null };

export type GetPayrollSummaryQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetPayrollSummaryQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getPayrollSummaryUsingGET?: Array<{ __typename?: 'payroll_PayrollSummaryRepresentation', clientEid?: string | null, angajatId?: string | null, externalId?: string | null, nume?: string | null, prenume?: string | null, contractNo?: string | null, modelContract?: string | null, nrOreNormale?: number | null, co?: number | null, cm?: number | null, totalOreSuplimentare?: number | null, tichete?: number | null, primaBruta?: number | null, avans?: number | null, retineri?: number | null, pensieFacultativa?: number | null, cdaBrut?: number | null, cdaNet?: number | null, cdaToateTaxele?: boolean | null, ramasPlata?: number | null, sporuri?: number | null }> | null } | null };

export type GetPayrollSummaryExpertQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetPayrollSummaryExpertQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getPayrollSummaryExpertUsingGET?: { __typename?: 'payroll_PayrollSummaryExpertRepresentation', success?: boolean | null, message?: string | null, data?: Array<{ __typename?: 'payroll_PayrollEmployeeSummaryExpertRepresentation', externalId?: string | null, nume?: string | null, prenume?: string | null, contractNo?: string | null, tarifarLunarBrut?: number | null, coValue?: number | null, cmValue?: number | null, tickete?: number | null, sporuri?: number | null, brutRealizat?: number | null, cas?: number | null, cass?: number | null, cam?: number | null, deducere?: number | null, impozit?: number | null, net?: number | null, retineri?: number | null, avans?: number | null, ramasPlata?: number | null, message?: string | null, hasOverrides?: boolean | null }> | null } | null } | null };

export type GetBenefitsReminderQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetBenefitsReminderQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getBenefitsReminderUsingGET?: { __typename?: 'payroll_BenefitsReminderRepresentation', showReminder?: boolean | null } | null } | null };

export type UpdateMonthStatusMutationVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
  closedByClient?: Types.InputMaybe<Types.Scalars['Boolean']>;
  closedByExpert?: Types.InputMaybe<Types.Scalars['Boolean']>;
  ignoreWarnings?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type UpdateMonthStatusMutation = { __typename?: 'Mutation', payroll?: { __typename?: 'payroll_mutation', updateStatusLunaCalculUsingPUT?: string | null } | null };

export type ComputeAllMutationVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type ComputeAllMutation = { __typename?: 'Mutation', payroll?: { __typename?: 'payroll_mutation', computePayrollUsingPOST?: { __typename?: 'payroll_SuccessResponse', Message?: string | null } | null } | null };

export type ComputeEmployeeMutationVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
  employeeEid?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type ComputeEmployeeMutation = { __typename?: 'Mutation', payroll?: { __typename?: 'payroll_mutation', computePayrollUsingPOST?: { __typename?: 'payroll_SuccessResponse', Message?: string | null } | null } | null };

export type UpdatePayrollOverridesMutationVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
  employeeEid?: Types.InputMaybe<Types.Scalars['String']>;
  req?: Types.InputMaybe<Types.Payroll_ModificareCalculSalariuRepresentationInput>;
}>;


export type UpdatePayrollOverridesMutation = { __typename?: 'Mutation', payroll?: { __typename?: 'payroll_mutation', putPayrollOverridesUsingPOST?: { __typename?: 'payroll_SuccessResponse', Message?: string | null } | null } | null };

export type GetLunaCdaQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetLunaCdaQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getLunaCdaUsingGET?: { __typename?: 'payroll_LunaCdaListRepresentation', data?: Array<{ __typename?: 'payroll_LunaCdaEmployeeRepresentation', employeeEid?: string | null, netCda?: number | null, cdaToateTaxele?: boolean | null, nume?: string | null, prenume?: string | null, contract?: string | null }> | null } | null } | null };

export type UpdateCdaDataMutationVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
  data?: Types.InputMaybe<Types.Payroll_LunaCdaRepresentationInput>;
}>;


export type UpdateCdaDataMutation = { __typename?: 'Mutation', payroll?: { __typename?: 'payroll_mutation', insertLunaCdaUsingPUT?: { __typename?: 'payroll_SuccessResponse', Message?: string | null } | null } | null };

export type GetLunaAlteSumeQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
  onlyWithBenefits?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type GetLunaAlteSumeQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getLunaAlteSumeUsingGET?: { __typename?: 'payroll_LunaAlteSumeListRepresentation', recordsCount?: number | null, first?: number | null, last?: number | null, data?: Array<{ __typename?: 'payroll_LunaAlteSumeEmployeeRepresentation', employeeEid?: string | null, nume?: string | null, prenume?: string | null, contract?: string | null, oreSuplimentare125?: number | null, oreSuplimentare150?: number | null, oreSuplimentare175?: number | null, oreSuplimentare200?: number | null, ticketeMasaNumar?: number | null, ticketeMasaValoare?: number | null, ticketeCadouNumar?: number | null, ticketeCadouValoare?: number | null, valoareBonusNet?: number | null, valoareBonusBrut?: number | null, valoareAvans?: number | null, valoareRetineri?: number | null, nrZileCoNeefectuat?: number | null, plecatInTimpulLunii?: boolean | null, valoarePensieFacultativa?: number | null, diurnaNeimpozabila?: number | null, asigurareVoluntaraSanatate?: number | null, abonamentSport?: number | null, telemunca?: number | null, valoarePensieFacultativaImpozabila?: number | null, diurnaImpozabila?: number | null, asigurareVoluntaraSanatateImpozabila?: number | null, abonamentSportImpozabila?: number | null, telemuncaImpozabila?: number | null }> | null } | null } | null };

export type UpdateLunaAlteSumeMutationVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
  data?: Types.InputMaybe<Types.Payroll_LunaAlteSumeRepresentationInput>;
}>;


export type UpdateLunaAlteSumeMutation = { __typename?: 'Mutation', payroll?: { __typename?: 'payroll_mutation', insertLunaAlteSumeUsingPUT?: { __typename?: 'payroll_SuccessResponse', Message?: string | null } | null } | null };

export type GetDateConstructiiQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetDateConstructiiQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getLunaDateConstructiiUsingGET?: { __typename?: 'payroll_LunaDateConstructiiRepresentation', constructiiCifraAfaceri?: number | null, constructiiCifraAfaceriDinConstructii?: number | null, constructiiCifraAfaceriAnAnterior?: number | null, constructiiCifraAfaceriDinConstructiiAnAnterior?: number | null, indeplinesteConditiiNecesareFacilitatiConstructii?: boolean | null } | null } | null };

export type UpdateDateConstructiiMutationVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  lunaCalcul?: Types.InputMaybe<Types.Scalars['Int']>;
  data?: Types.InputMaybe<Types.Payroll_LunaDateConstructiiRepresentationInput>;
}>;


export type UpdateDateConstructiiMutation = { __typename?: 'Mutation', payroll?: { __typename?: 'payroll_mutation', insertLunaDateConstructiiUsingPUT?: { __typename?: 'payroll_SuccessResponse', Message?: string | null } | null } | null };

export type VacationListQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  anLuna: Types.Scalars['Int'];
}>;


export type VacationListQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getConcediuUsingGET?: { __typename?: 'payroll_ConcediiClientListRepresentation', recordsCount?: number | null, first?: number | null, last?: number | null, data?: { __typename?: 'payroll_ConcediiClientRepresentation', clientEid?: string | null, anLuna?: number | null, monthStart?: number | null, monthEnd?: number | null, zileSL?: Array<number> | null, zileSD?: Array<number> | null, employees?: Array<{ __typename?: 'payroll_ConcediuEmployeeViewRepresentation', employeeEid?: string | null, nume?: string | null, prenume?: string | null, contract?: string | null, numarOre?: number | null, contractStartDate?: number | null, contractEndDate?: number | null, tipNorma?: { __typename?: 'payroll_SysTipNormaRepresentation', id?: number | null, code?: string | null, display?: string | null } | null, modelContract?: { __typename?: 'payroll_SysModelContractRepresentation', id?: number | null, code?: string | null, display?: string | null, permitePontaj?: boolean | null, utilizabilClient?: boolean | null } | null, repartizareTipMunca?: { __typename?: 'payroll_SysRepartizareTimpMuncaRepresentation', id?: number | null, code?: string | null, display?: string | null } | null, tipOre?: { __typename?: 'payroll_SysTipOre', id?: number | null, code?: string | null, display?: string | null } | null, suspendari?: Array<{ __typename?: 'payroll_SuspendareRepresentation', motivSuspendareId?: number | null, deLa?: number | null, panaLa?: number | null, dataRevenire?: number | null, documentEid?: string | null, activ?: boolean | null, motivSuspendare?: { __typename?: 'payroll_SysMotivSuspendareRepresentation', id?: number | null, code?: string | null, display?: string | null } | null }> | null, concedii?: Array<{ __typename?: 'payroll_ConcediuRepresentation', zi?: number | null, tipConcediuId?: number | null, tipConcediu?: { __typename?: 'payroll_SysTipConcediuRepresentation', id?: number | null, code?: string | null, display?: string | null } | null }> | null, istoricNorma?: Array<{ __typename?: 'payroll_IstoricNormaRepresentation', norma?: number | null, dateFrom?: number | null, dateTo?: number | null }> | null, istoricTipOre?: Array<{ __typename?: 'payroll_IstoricTipOreRepresentation', dateFrom?: number | null, dateTo?: number | null, tipOre?: { __typename?: 'payroll_SysTipOre', id?: number | null, code?: string | null, display?: string | null } | null }> | null }> | null } | null } | null } | null };

export type SaveVacationsMutationVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  anLuna: Types.Scalars['Int'];
  data: Types.Payroll_ConcediiRepresentationInput;
}>;


export type SaveVacationsMutation = { __typename?: 'Mutation', payroll?: { __typename?: 'payroll_mutation', insertConcediuUsingPUT?: { __typename?: 'payroll_SuccessResponse', Message?: string | null } | null } | null };

export type DeleteVacationsMutationVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  anLuna: Types.Scalars['Int'];
  data: Types.Payroll_ConcediuEmployeeDeleteEidsRepresentationInput;
}>;


export type DeleteVacationsMutation = { __typename?: 'Mutation', payroll?: { __typename?: 'payroll_mutation', deleteConcediuUsingDELETE?: { __typename?: 'payroll_SuccessResponse', Message?: string | null } | null } | null };

export type SoldConcediuListQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  anLuna: Types.Scalars['Int'];
}>;


export type SoldConcediuListQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getEmployeesSoldConcediuOdihnaUsingGET?: { __typename?: 'payroll_SoldConcediuOdihnaListRepresentation', recordsCount?: number | null, first?: number | null, last?: number | null, clientEid?: string | null, anLuna?: number | null, data?: Array<{ __typename?: 'payroll_SoldConcediuOdihnaEmployeeViewRepresentation', employeeEid?: string | null, nume?: string | null, prenume?: string | null, contractNo?: string | null, nrZileCoAnterior?: number | null, modificatManual?: boolean | null, coAnualContract?: number | null, coCalculatLuna?: number | null, coFolosit?: number | null, coPlatit?: number | null, coRamasLuna?: number | null, coRamasFinalAn?: number | null, coPlanificatInViitor?: number | null, coNeplanificat?: number | null }> | null } | null } | null };

export type SaveVacationBalanceMutationVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  anLuna: Types.Scalars['Int'];
  data: Types.Payroll_SoldConcediuOdihnaRepresentationInput;
}>;


export type SaveVacationBalanceMutation = { __typename?: 'Mutation', payroll?: { __typename?: 'payroll_mutation', insertSoldConcediuOdihnaUsingPUT?: { __typename?: 'payroll_SuccessResponse', Message?: string | null } | null } | null };

export type GetEmployeeLeaveDateQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
  externalId: Types.Scalars['String'];
  atDate?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type GetEmployeeLeaveDateQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getEmployeeUsingGET?: { __typename?: 'payroll_EmployeeViewRepresentation', externalId?: string | null, dataPlecarii?: number | null } | null } | null };

export type GetNewOutDocNumberForClientQueryVariables = Types.Exact<{
  clientEid: Types.Scalars['String'];
}>;


export type GetNewOutDocNumberForClientQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getNewOutDocNumberForClientUsingGET?: { __typename?: 'payroll_RegistrarOutDocNumberRepresentation', newDocNumber?: number | null } | null } | null };

export type GetTimesheetAutoClosePromptQueryVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type GetTimesheetAutoClosePromptQuery = { __typename?: 'Query', payroll?: { __typename?: 'payroll', getTimesheetAutoClosePromptUsingGET?: { __typename?: 'payroll_TimesheetAutoClosePromptRepresentation', shouldPrompt?: boolean | null, autoClose?: boolean | null } | null } | null };

export type UpdateTimesheetAutoCloseMutationVariables = Types.Exact<{
  clientEid?: Types.InputMaybe<Types.Scalars['String']>;
  autoClose?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type UpdateTimesheetAutoCloseMutation = { __typename?: 'Mutation', accounts?: { __typename?: 'accounts_mutation', putTimesheetAutoCloseUsingPUT?: { __typename?: 'accounts_SuccessResponse', Message?: string | null } | null } | null };

export const GetCurrentLunaCalculDocument = gql`
    query getCurrentLunaCalcul($clientEid: String, $userRole: String) {
  payroll {
    getCurrentLunaCalculUsingGET(clientEid: $clientEid, userRole: $userRole) {
      month
      closedByClient
      closedByExpert
      errorCloseByExpert
      errorOpenByExpert
      blocata
    }
  }
  accounts {
    getSuperExpertProgressManagementPayrollStatusUsingGET(clientEid: $clientEid) {
      payrollStartMonth
      payrollType
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentLunaCalculGQL extends Apollo.Query<GetCurrentLunaCalculQuery, GetCurrentLunaCalculQueryVariables> {
    document = GetCurrentLunaCalculDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetClientCaenDataDocument = gql`
    query getClientCaenData($clientEid: String, $atDate: Int, $eom: Boolean) {
  accounts {
    GetClientUsingGET(clientEid: $clientEid, atDate: $atDate, eom: $eom) {
      externalId
      sysCaenCode {
        code
        description
      }
      sysConstructionCaenCode {
        code
        description
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetClientCaenDataGQL extends Apollo.Query<GetClientCaenDataQuery, GetClientCaenDataQueryVariables> {
    document = GetClientCaenDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetStatusLunaCalculDocument = gql`
    query getStatusLunaCalcul($clientEid: String, $lunaCalcul: Int) {
  payroll {
    getStatusLunaCalculUsingGET(clientEid: $clientEid, lunaCalcul: $lunaCalcul) {
      month
      closedByClient
      closedByExpert
      errorCloseByExpert
      errorOpenByExpert
      blocata
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetStatusLunaCalculGQL extends Apollo.Query<GetStatusLunaCalculQuery, GetStatusLunaCalculQueryVariables> {
    document = GetStatusLunaCalculDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPayrollSummaryDocument = gql`
    query getPayrollSummary($clientEid: String, $lunaCalcul: Int) {
  payroll {
    getPayrollSummaryUsingGET(clientEid: $clientEid, lunaCalcul: $lunaCalcul) {
      clientEid
      angajatId
      externalId
      nume
      prenume
      contractNo
      modelContract
      nrOreNormale
      co
      cm
      totalOreSuplimentare
      tichete
      primaBruta
      avans
      retineri
      pensieFacultativa
      cdaBrut
      cdaNet
      cdaToateTaxele
      ramasPlata
      sporuri
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPayrollSummaryGQL extends Apollo.Query<GetPayrollSummaryQuery, GetPayrollSummaryQueryVariables> {
    document = GetPayrollSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetPayrollSummaryExpertDocument = gql`
    query getPayrollSummaryExpert($clientEid: String, $lunaCalcul: Int) {
  payroll {
    getPayrollSummaryExpertUsingGET(clientEid: $clientEid, lunaCalcul: $lunaCalcul) {
      success
      message
      data {
        externalId
        nume
        prenume
        contractNo
        tarifarLunarBrut
        coValue
        cmValue
        tickete
        sporuri
        brutRealizat
        cas
        cass
        cam
        deducere
        impozit
        net
        retineri
        avans
        ramasPlata
        message
        hasOverrides
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetPayrollSummaryExpertGQL extends Apollo.Query<GetPayrollSummaryExpertQuery, GetPayrollSummaryExpertQueryVariables> {
    document = GetPayrollSummaryExpertDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBenefitsReminderDocument = gql`
    query getBenefitsReminder($clientEid: String, $lunaCalcul: Int) {
  payroll {
    getBenefitsReminderUsingGET(clientEid: $clientEid, lunaCalcul: $lunaCalcul) {
      showReminder
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBenefitsReminderGQL extends Apollo.Query<GetBenefitsReminderQuery, GetBenefitsReminderQueryVariables> {
    document = GetBenefitsReminderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMonthStatusDocument = gql`
    mutation updateMonthStatus($clientEid: String, $lunaCalcul: Int, $closedByClient: Boolean, $closedByExpert: Boolean, $ignoreWarnings: Boolean) {
  payroll {
    updateStatusLunaCalculUsingPUT(clientEid: $clientEid, lunaCalcul: $lunaCalcul, req: {month: $lunaCalcul, closedByClient: $closedByClient, closedByExpert: $closedByExpert, ignoreWarnings: $ignoreWarnings})
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMonthStatusGQL extends Apollo.Mutation<UpdateMonthStatusMutation, UpdateMonthStatusMutationVariables> {
    document = UpdateMonthStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ComputeAllDocument = gql`
    mutation computeAll($clientEid: String, $lunaCalcul: Int) {
  payroll {
    computePayrollUsingPOST(clientEid: $clientEid, lunaCalcul: $lunaCalcul, req: {}) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ComputeAllGQL extends Apollo.Mutation<ComputeAllMutation, ComputeAllMutationVariables> {
    document = ComputeAllDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ComputeEmployeeDocument = gql`
    mutation computeEmployee($clientEid: String, $lunaCalcul: Int, $employeeEid: String) {
  payroll {
    computePayrollUsingPOST(clientEid: $clientEid, lunaCalcul: $lunaCalcul, req: {employeeEid: $employeeEid}) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ComputeEmployeeGQL extends Apollo.Mutation<ComputeEmployeeMutation, ComputeEmployeeMutationVariables> {
    document = ComputeEmployeeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePayrollOverridesDocument = gql`
    mutation updatePayrollOverrides($clientEid: String, $lunaCalcul: Int, $employeeEid: String, $req: payroll_ModificareCalculSalariuRepresentationInput) {
  payroll {
    putPayrollOverridesUsingPOST(clientEid: $clientEid, employeeEid: $employeeEid, lunaCalcul: $lunaCalcul, req: $req) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePayrollOverridesGQL extends Apollo.Mutation<UpdatePayrollOverridesMutation, UpdatePayrollOverridesMutationVariables> {
    document = UpdatePayrollOverridesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLunaCdaDocument = gql`
    query getLunaCda($clientEid: String, $lunaCalcul: Int) {
  payroll {
    getLunaCdaUsingGET(clientEid: $clientEid, anLuna: $lunaCalcul) {
      data {
        employeeEid
        netCda
        cdaToateTaxele
        nume
        prenume
        contract
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLunaCdaGQL extends Apollo.Query<GetLunaCdaQuery, GetLunaCdaQueryVariables> {
    document = GetLunaCdaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCdaDataDocument = gql`
    mutation updateCDAData($clientEid: String, $lunaCalcul: Int, $data: payroll_LunaCdaRepresentationInput) {
  payroll {
    insertLunaCdaUsingPUT(clientEid: $clientEid, anLuna: $lunaCalcul, data: $data) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCdaDataGQL extends Apollo.Mutation<UpdateCdaDataMutation, UpdateCdaDataMutationVariables> {
    document = UpdateCdaDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLunaAlteSumeDocument = gql`
    query getLunaAlteSume($clientEid: String, $lunaCalcul: Int, $onlyWithBenefits: Boolean) {
  payroll {
    getLunaAlteSumeUsingGET(clientEid: $clientEid, anLuna: $lunaCalcul, onlyWithBenefits: $onlyWithBenefits) {
      recordsCount
      first
      last
      data {
        employeeEid
        nume
        prenume
        contract
        oreSuplimentare125
        oreSuplimentare150
        oreSuplimentare175
        oreSuplimentare200
        ticketeMasaNumar
        ticketeMasaValoare
        ticketeCadouNumar
        ticketeCadouValoare
        valoareBonusNet
        valoareBonusBrut
        valoareAvans
        valoareRetineri
        nrZileCoNeefectuat
        plecatInTimpulLunii
        valoarePensieFacultativa
        diurnaNeimpozabila
        asigurareVoluntaraSanatate
        abonamentSport
        telemunca
        valoarePensieFacultativaImpozabila
        diurnaImpozabila
        asigurareVoluntaraSanatateImpozabila
        abonamentSportImpozabila
        telemuncaImpozabila
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLunaAlteSumeGQL extends Apollo.Query<GetLunaAlteSumeQuery, GetLunaAlteSumeQueryVariables> {
    document = GetLunaAlteSumeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLunaAlteSumeDocument = gql`
    mutation updateLunaAlteSume($clientEid: String, $lunaCalcul: Int, $data: payroll_LunaAlteSumeRepresentationInput) {
  payroll {
    insertLunaAlteSumeUsingPUT(clientEid: $clientEid, anLuna: $lunaCalcul, data: $data) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLunaAlteSumeGQL extends Apollo.Mutation<UpdateLunaAlteSumeMutation, UpdateLunaAlteSumeMutationVariables> {
    document = UpdateLunaAlteSumeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDateConstructiiDocument = gql`
    query getDateConstructii($clientEid: String, $lunaCalcul: Int) {
  payroll {
    getLunaDateConstructiiUsingGET(clientEid: $clientEid, anLuna: $lunaCalcul) {
      constructiiCifraAfaceri
      constructiiCifraAfaceriDinConstructii
      constructiiCifraAfaceriAnAnterior
      constructiiCifraAfaceriDinConstructiiAnAnterior
      indeplinesteConditiiNecesareFacilitatiConstructii
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDateConstructiiGQL extends Apollo.Query<GetDateConstructiiQuery, GetDateConstructiiQueryVariables> {
    document = GetDateConstructiiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDateConstructiiDocument = gql`
    mutation updateDateConstructii($clientEid: String, $lunaCalcul: Int, $data: payroll_LunaDateConstructiiRepresentationInput) {
  payroll {
    insertLunaDateConstructiiUsingPUT(clientEid: $clientEid, anLuna: $lunaCalcul, data: $data) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDateConstructiiGQL extends Apollo.Mutation<UpdateDateConstructiiMutation, UpdateDateConstructiiMutationVariables> {
    document = UpdateDateConstructiiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VacationListDocument = gql`
    query vacationList($clientEid: String!, $anLuna: Int!) {
  payroll {
    getConcediuUsingGET(clientEid: $clientEid, anLuna: $anLuna) {
      recordsCount
      first
      last
      data {
        clientEid
        anLuna
        monthStart
        monthEnd
        zileSL
        zileSD
        employees {
          employeeEid
          nume
          prenume
          contract
          tipNorma {
            id
            code
            display
          }
          modelContract {
            id
            code
            display
            permitePontaj
            utilizabilClient
          }
          repartizareTipMunca {
            id
            code
            display
          }
          tipOre {
            id
            code
            display
          }
          suspendari {
            motivSuspendareId
            deLa
            panaLa
            dataRevenire
            documentEid
            activ
            motivSuspendare {
              id
              code
              display
            }
          }
          numarOre
          contractStartDate
          contractEndDate
          concedii {
            zi
            tipConcediuId
            tipConcediu {
              id
              code
              display
            }
          }
          istoricNorma {
            norma
            dateFrom
            dateTo
          }
          istoricTipOre {
            tipOre {
              id
              code
              display
            }
            dateFrom
            dateTo
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VacationListGQL extends Apollo.Query<VacationListQuery, VacationListQueryVariables> {
    document = VacationListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveVacationsDocument = gql`
    mutation saveVacations($clientEid: String!, $anLuna: Int!, $data: payroll_ConcediiRepresentationInput!) {
  payroll {
    insertConcediuUsingPUT(clientEid: $clientEid, anLuna: $anLuna, data: $data) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveVacationsGQL extends Apollo.Mutation<SaveVacationsMutation, SaveVacationsMutationVariables> {
    document = SaveVacationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVacationsDocument = gql`
    mutation deleteVacations($clientEid: String!, $anLuna: Int!, $data: payroll_ConcediuEmployeeDeleteEidsRepresentationInput!) {
  payroll {
    deleteConcediuUsingDELETE(clientEid: $clientEid, anLuna: $anLuna, data: $data) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteVacationsGQL extends Apollo.Mutation<DeleteVacationsMutation, DeleteVacationsMutationVariables> {
    document = DeleteVacationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SoldConcediuListDocument = gql`
    query soldConcediuList($clientEid: String!, $anLuna: Int!) {
  payroll {
    getEmployeesSoldConcediuOdihnaUsingGET(clientEid: $clientEid, anLuna: $anLuna) {
      recordsCount
      first
      last
      clientEid
      anLuna
      data {
        employeeEid
        nume
        prenume
        contractNo
        nrZileCoAnterior
        modificatManual
        coAnualContract
        coCalculatLuna
        coFolosit
        coPlatit
        coRamasLuna
        coRamasFinalAn
        coPlanificatInViitor
        coNeplanificat
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SoldConcediuListGQL extends Apollo.Query<SoldConcediuListQuery, SoldConcediuListQueryVariables> {
    document = SoldConcediuListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveVacationBalanceDocument = gql`
    mutation saveVacationBalance($clientEid: String!, $anLuna: Int!, $data: payroll_SoldConcediuOdihnaRepresentationInput!) {
  payroll {
    insertSoldConcediuOdihnaUsingPUT(clientEid: $clientEid, anLuna: $anLuna, data: $data) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveVacationBalanceGQL extends Apollo.Mutation<SaveVacationBalanceMutation, SaveVacationBalanceMutationVariables> {
    document = SaveVacationBalanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmployeeLeaveDateDocument = gql`
    query getEmployeeLeaveDate($clientEid: String!, $externalId: String!, $atDate: Int) {
  payroll {
    getEmployeeUsingGET(clientEid: $clientEid, externalId: $externalId, atDate: $atDate) {
      externalId
      dataPlecarii
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmployeeLeaveDateGQL extends Apollo.Query<GetEmployeeLeaveDateQuery, GetEmployeeLeaveDateQueryVariables> {
    document = GetEmployeeLeaveDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNewOutDocNumberForClientDocument = gql`
    query getNewOutDocNumberForClient($clientEid: String!) {
  payroll {
    getNewOutDocNumberForClientUsingGET(clientEid: $clientEid) {
      newDocNumber
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNewOutDocNumberForClientGQL extends Apollo.Query<GetNewOutDocNumberForClientQuery, GetNewOutDocNumberForClientQueryVariables> {
    document = GetNewOutDocNumberForClientDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTimesheetAutoClosePromptDocument = gql`
    query getTimesheetAutoClosePrompt($clientEid: String) {
  payroll {
    getTimesheetAutoClosePromptUsingGET(clientEid: $clientEid) {
      shouldPrompt
      autoClose
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTimesheetAutoClosePromptGQL extends Apollo.Query<GetTimesheetAutoClosePromptQuery, GetTimesheetAutoClosePromptQueryVariables> {
    document = GetTimesheetAutoClosePromptDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTimesheetAutoCloseDocument = gql`
    mutation updateTimesheetAutoClose($clientEid: String, $autoClose: Boolean) {
  accounts {
    putTimesheetAutoCloseUsingPUT(clientEid: $clientEid, data: {autoClose: $autoClose}) {
      Message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTimesheetAutoCloseGQL extends Apollo.Mutation<UpdateTimesheetAutoCloseMutation, UpdateTimesheetAutoCloseMutationVariables> {
    document = UpdateTimesheetAutoCloseDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }